import { Component, OnInit, ComponentFactoryResolver, ViewContainerRef, ViewChild } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../core/config/Constants';
import { UtilityService } from '../../core/services/utility.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { SessionService } from '../../core/services/session.service';
import { Session } from '../../core/models/session';
import { eventNames } from 'cluster';
import { DatePipe } from '@angular/common';
import { setTimeout } from 'timers';
import { AngularFireDatabase, AngularFireObject, AngularFireList } from 'angularfire2/database';

import { NewPageList } from '../../core/models/new-page-list';
import { NewPageService } from '../../templates/new-page/service/new-page.service';
import { DropDownComponent } from '../../layout/drop-down/drop-down.component';
import { MultiUtilityService } from '../../core/services/multi-utility.service';
import { Category } from '../../core/models/category';
import { Listing } from '../../core/models/listing';
import { SessionHall } from '../../core/models/session-hall';
import { SessionType } from '../../core/models/session-type';
import { SessionTrack } from '../../core/models/session-track';

/** bulk upload imports start */
import * as XLSX from 'xlsx';
import { FileUpload } from 'primeng/primeng';
import { ExportImportSessionService } from '../../core/services/export-import-session.service';
/** bulk upload imports end */

@Component({
  selector: 'app-sessions-form',
  templateUrl: './sessions-form.component.html',
  styleUrls: ['./sessions-form.component.css'],
  providers: [ExtraService, UtilityService, DatePipe, NewPageService, ExportImportSessionService]
})
export class SessionsFormComponent implements OnInit {
  buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;

  @ViewChild('dropDown', { read: ViewContainerRef }) dropDown: ViewContainerRef;

  eventID: string;
  message: string;
  sessionId: string = null;
  title: string = 'Session Data';
  startTime: string;
  SessionEmptyId: string = null;
  sessionList = new Array<Session>();
  sessionDeleteList = new Array<string>();
  session = new Session();
  checkData: boolean = false;
  date_format = Constants.PUBLISH_AT_DATE_FORMAT;

  eventHighlights = {
    hasHighlights: false,
    allowTopicFavourite: false,
    hasCustomTitle: false,
    customTitle: '',
    highlights: new Array<NewPageList>()
  };

  categoryItemNewText: string = null;
  trackColorNewText: string = null;
  hasCategoryOrderChanged: boolean = false;
  sessionTrackList: Array<SessionTrack> = new Array();
  categoryDeletedIdList: Array<string> = new Array();
  listing = new Listing();

  sessionTypeItemNewText: string = null;
  sessionTypeItemColorText: string = null;
  
  hasSessionTypeOrderChanged: boolean = false;
  sessionTypeList: Array<SessionType> = new Array();
  sessionTypeDeletedIdList: Array<string> = new Array();
  sessionType = new Listing();

  sessionHallItemNewText: string = null;
  hasSessionHallOrderChanged: boolean = false;
  sessionHallList: Array<SessionHall> = new Array();
  sessionHallDeletedIdList: Array<string> = new Array();
  sessionHall = new SessionHall();

  selectedFile: File = null;
  aliasId: string;
  allSessionTopics:any=[];
  sessionTopics:any=[];


  /** bulk upload variable start */
  allSession = new Array<Session>();
  newImportSession = new Array<Session>();
  updateImportSession = new Array<Session>();
  keys = {
    id: "Id",
    name: "Name",
    endTime: 'End Time',
    startTime: 'Start Time',
    location: 'Location',

    hasDetailsScreen: 'Details Screen',
    isQuestionAllowed: 'Q&A',
    allowFeedback: 'Feedback',
    hasPolls: 'Polls',
    hasChatroom: 'Chatroom',
    // hasCustomDescription: 'has Custom Description',
    // hasDifferentVenue: 'has Different Venue',
    // isQuestionAllowed: 'is Question Allowed',
    // hasHeader: 'has Header',
    // location: 'location',
    // locationAddress: 'location Address',
    // showVenueTab: 'show Venue Tab',
    position: 'position',
  };
  /** bulk upload variable end */

  constructor(private db: AngularFireDatabase, private extraService: ExtraService, public datepipe: DatePipe, private route: ActivatedRoute, private confirmationService: ConfirmationService,
    private sessionService: SessionService, private utilityService: UtilityService, private router: Router, private _cfr: ComponentFactoryResolver, private newPageService: NewPageService, private multiUtilityService: MultiUtilityService, private eximSessionService: ExportImportSessionService, ) { }

  ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.route.params.subscribe(params => {

      console.log("PageParams", params);
      if (params['eventId']) {
        this.eventID = params['eventId'];
        this.extraService.setCurrentEventId(params['eventId']);
        this.checkData = true;
        this.getSessionList(params['eventId']);
        this.getSessionHighlights(params['eventId']);
        this.getEventAliasId(params['eventId']);
        this.getAllTopicsForSession(params['eventId']);

        this.initSessionTrackList(params['eventId']);
        this.multiUtilityService.getPrefListing(params['eventId'], Constants.LIST_CATEGORY_SPEAKER).subscribe(pref => {
          this.listing.has_category_track = pref;
        });

        /** session type start */
        this.initSessionType(params['eventId']);
        this.multiUtilityService.getPrefListing(params['eventId'], Constants.LIST_CATEGORY_TYPE).subscribe(pref => {
          this.listing.has_category_type = pref;
        });
        /** session type end */

        /** session Hall start */
        this.initSessionHalls(params['eventId']);
        this.multiUtilityService.getPrefListing(params['eventId'], Constants.NODE_PREF_SESSION_HSH).subscribe(pref => {
          this.listing.hasSessionHalls = pref;
        });
        /** session type end */

        console.log('this.getSessionHighlights');
      }
    });
    this.newPageService.up$.subscribe(data => {
      if (data != null) {
        let index = this.eventHighlights.highlights.indexOf(data);
        if (index > 0) {
          this.swapHeighlightsDescription(index, index - 1);
        }
      }
    });
    this.newPageService.down$.subscribe(data => {
      if (data != null) {
        let index = this.eventHighlights.highlights.indexOf(data);
        if (index < this.eventHighlights.highlights.length - 1) {
          this.swapHeighlightsDescription(index, index + 1);
        }
      }
    });
    this.newPageService.remove$.subscribe(data => {
      if (data != null) {
        let index = this.eventHighlights.highlights.indexOf(data);
        //console.log(index);
        if (index != -1) {
          this.remove(index);
        }
      }
    });
  }


  getAllTopicsForSession(event_id){
    this.sessionService.getAllSessionTopics(event_id).then(item => {
      this.sessionTopics=item.val()
      console.log("sesionTopics",this.sessionTopics)
    });
  }
  getSessionHighlights(event_id) {
    this.sessionService.getSessionHighlights(event_id).subscribe(item => {
      console.log("getSessionHighlights",item);
      if (item) {
        for (let key in item) {
          this.eventHighlights[key] = item[key];
        }
        if (this.eventHighlights.highlights.length > 0) {
          this.eventHighlights.highlights.forEach(element => {
            this.addComponent(element);
          });
        }
      }
    });
  }

  showDropDown() {
    console.log('showDropDown');
    let aboutUs = new NewPageList();
    var dropDown = this._cfr.resolveComponentFactory(DropDownComponent);
    var expComponent = this.dropDown.createComponent(dropDown);
    this.eventHighlights.highlights.push(aboutUs);
    expComponent.instance.eventId = this.eventID;
    expComponent.instance._ref = expComponent;
    expComponent.instance.cmCategory = Constants.CONTENT_M_TYPE_SESSION;
    expComponent.instance.aboutUs = this.eventHighlights.highlights[this.eventHighlights.highlights.length - 1];
  }

  addComponent(about: NewPageList) {
    console.log('addComponent');
    var dropDown = this._cfr.resolveComponentFactory(DropDownComponent);
    var expComponent = this.dropDown.createComponent(dropDown);
    expComponent.instance.eventId = this.eventID;
    expComponent.instance._ref = expComponent;
    expComponent.instance.cmCategory = Constants.CONTENT_M_TYPE_SESSION;
    expComponent.instance.aboutUs = about;
    if (about.type == 'image') {
      expComponent.instance.addImage();
    } else if (about.type == 'text') {
      expComponent.instance.addTextBox();
    } else if (about.type == 'cards') {
      expComponent.instance.addCards();
    } else if (about.type == 'video') {
      expComponent.instance.addVideo();
    } else if (about.type == 'url') {
      expComponent.instance.addUrlBox();
    } else if (about.type == 'youtubeVideo') {
      expComponent.instance.addYoutube();
    } else if (about.type == 'imageSlider') {
      expComponent.instance.addImageSlider();
    } else if (about.type == 'list') {
      expComponent.instance.addList();
    } else {
      expComponent.instance.addStatic(about.type);
    }
  }

  swapHeighlightsDescription(index1, index2) {
    this.dropDown.move(this.dropDown.get(index1), index2);
    let data = this.eventHighlights.highlights[index1];
    this.eventHighlights.highlights[index1] = this.eventHighlights.highlights[index2];
    this.eventHighlights.highlights[index2] = data;
  }

  remove(index) {
    this.eventHighlights.highlights = this.eventHighlights.highlights.filter((val, i) => i != index);
  }



  selectedStartTime: string = null;
  getSessionList(id) {
    // debugger;
    this.message = null;
    var x = this.sessionService.getSessionList(id)
    this.initSessionHalls(id)
    x.snapshotChanges().subscribe(list => {
      // debugger;
      if (this.checkData) {
        this.sessionDeleteList = new Array();
        this.sessionList = new Array();
        list.forEach(element => {
          var y = element.payload.toJSON() as Session;
          if (element.key) {
            //debugger
            let location = this.sessionHallList.filter(x=>x.$key == y.location);
            y["$key"] = element.key;
            y.venueName = location.length > 0 ? location[0].name : y.location == undefined ? "" : y.location ;
            y.startTime = new Date(this.stringToFormatedDateString(y.startTime)).toString();

            this.sessionList[y.position] = (y as Session);
          }
        });
        console.log(this.sessionList,this.sessionHallList);
        this.checkData = false;
      }
    });

  }

  stringToFormatedDateString(str: string): string {
    let formatedDateString = str;
    if (str != null && str.length == Constants.DATE_TIME_FORMAT.length) {
      formatedDateString = str.substring(4, 8) + '-' + str.substring(2, 4) + '-' + str.substring(0, 2) + 'T' + str.substring(9);
    } else {
      formatedDateString = "htjykyu";
    }
    return formatedDateString;
  }



  upMenuItem(index) {
    if (index != 0) {
      this.swap(index, index - 1);
    }
  }

  downMenuItem(index) {
    if (index != this.sessionList.length - 1) {
      this.swap(index, index + 1);
    }
  }

  swap(index1, index2) {
    let data = this.sessionList[index1];
    this.sessionList[index1] = this.sessionList[index2];
    this.sessionList[index2] = data;
  }

  confirmDelete(event: Session) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete Session: ' + event.name + '?',
      accept: () => {
        this.deleteEvent(event);
      }
    });
  }

  deleteEvent(event) {
    let index: number = this.sessionList.indexOf(event);
    if (index !== -1) {
      this.sessionList.splice(index, 1);
      for (var i = 0; i < this.sessionList.length; i++) {
        this.sessionList[i].position = i;
      }
    }

    this.sessionService.deleteSessionID(event, this.eventID, this.sessionList).then(res => {
      this.message = "Session deleted Successfully";
      setTimeout(() => {
        this.message = null;
        this.checkData = true;
        this.getSessionList(this.eventID);
      }, 1000);
    }).catch(error => {
      console.log(error.message);
    });


  }

  submit() {
    console.log(this.eventHighlights);
    for (var i = 0; i < this.sessionList.length; i++) {
      this.sessionList[i].position = i;
    }

    this.sessionService.setSessionHighlights(this.eventID, this.eventHighlights);

    this.sessionService.updateSessionPosition(this.eventID, this.sessionList, this.sessionDeleteList);
    if (this.sessionDeleteList.length > 0) {
      this.message = "Session deleted Successfully";
    } else {
      this.message = "Session orderd Successfully";
    }

    /** session track start */
    if (this.hasCategoryOrderChanged) {
      for (let i = 0; i < this.sessionTrackList.length; i++) {
        this.sessionTrackList[i].position = i;
      }
      let key = this.multiUtilityService.addCategoryItem2(this.eventID, this.sessionTrackList, Constants.CATEGORY_SESSION_TRACK);
      if (this.categoryDeletedIdList.length > 0) {
        for (let item of this.categoryDeletedIdList) {
          this.multiUtilityService.deleteCategoryItem(this.eventID, item, Constants.CATEGORY_SESSION_TRACK).then(res => {
            this.message = 'Category deleted Successfully';
            if (this.categoryDeletedIdList.indexOf(item) == this.categoryDeletedIdList.length) {
              this.initSessionTrackList(this.eventID);
            }
          });
        }
      } else {
        this.message = 'Category ordered Successfully';
      }
      setTimeout(() => {
        this.message = null;
        this.checkData = true;
      }, 2000);
    }
    this.multiUtilityService.updatePrefListing(this.eventID, Constants.LIST_CATEGORY_SPEAKER, this.listing.has_category_track);
    /** session track end */


    /** session type start */
    if (this.hasSessionTypeOrderChanged) {
      for (let i = 0; i < this.sessionTypeList.length; i++) {
        this.sessionTypeList[i].position = i;
      }
      let key = this.multiUtilityService.addCategoryItem2(this.eventID, this.sessionTypeList, Constants.CATEGORY_SESSION_TYPE);
      if (this.sessionTypeDeletedIdList.length > 0) {
        for (let item of this.sessionTypeDeletedIdList) {
          this.multiUtilityService.deleteCategoryItem(this.eventID, item, Constants.CATEGORY_SESSION_TYPE).then(res => {
            this.message = 'Category deleted Successfully';
            if (this.sessionTypeDeletedIdList.indexOf(item) == this.sessionTypeDeletedIdList.length) {
              this.initSessionType(this.eventID);
            }
          });
        }
      } else {
        this.message = 'Category ordered Successfully';
      }
      setTimeout(() => {
        this.message = null;
        this.checkData = true;
      }, 2000);
    }
    this.multiUtilityService.updatePrefListing(this.eventID, Constants.LIST_CATEGORY_TYPE, this.listing.has_category_type);
    /** session type end */

    /** session hall start */
    if (this.hasSessionHallOrderChanged) {
      for (let i = 0; i < this.sessionHallList.length; i++) {
        this.sessionHallList[i].position = i;
      }
      let key = this.multiUtilityService.addCategoryItem2(this.eventID, this.sessionHallList, Constants.NODE_SESSION_HALL);
      if (this.sessionHallDeletedIdList.length > 0) {
        for (let item of this.sessionHallDeletedIdList) {
          this.multiUtilityService.deleteCategoryItem(this.eventID, item, Constants.NODE_SESSION_HALL).then(res => {
            this.message = 'Hall deleted Successfully';
            if (this.sessionHallDeletedIdList.indexOf(item) == this.sessionHallDeletedIdList.length) {
              this.initSessionHalls(this.eventID);
            }
          });
        }
      } else {
        this.message = 'Category ordered Successfully';
      }
      setTimeout(() => {
        this.message = null;
        this.checkData = true;
      }, 2000);
    }
    this.multiUtilityService.updatePrefListing(this.eventID, Constants.NODE_PREF_SESSION_HSH, this.listing.hasSessionHalls);
    /** session hall end */

    setTimeout(() => {
      this.message = null;
      this.checkData = true;
      this.getSessionList(this.eventID);
    }, 2000);
  }


  /** Category start */

  initSessionTrackList(eventId) {
    this.multiUtilityService.getCategoryList(eventId, Constants.CATEGORY_SESSION_TRACK).subscribe(event => {
      console.log("initCategoryList",event);
      if (event) {
        this.sessionTrackList = new Array();
        for (let key in event) {
          let sessionTrack = new SessionTrack();
          sessionTrack.$key = key;
          sessionTrack.position = event[key].position;
          sessionTrack.name = event[key].name;
          sessionTrack.color = event[key].color;
          this.sessionTrackList[event[key].position] = sessionTrack;
        }
        console.log('initSessionTrackList count	:	' + this.sessionTrackList.length);
      }
    });
  }

  onCategoryTextChange() {
    console.log('jnkjn');
    this.hasCategoryOrderChanged = true;
  }

  onCategoryColorChange() {
    console.log('jnkjn2');
    this.hasCategoryOrderChanged = true;
  }

  addSessionTrackItem() {
    if (this.categoryItemNewText != null && this.categoryItemNewText.trim().length > 0) {
      this.hasCategoryOrderChanged = true;

      let sessionTrackItem = new SessionTrack();
      sessionTrackItem.$key = null;
      sessionTrackItem.position = this.sessionTrackList.length;
      sessionTrackItem.name = this.categoryItemNewText;
      sessionTrackItem.color = this.trackColorNewText;
      this.sessionTrackList.push(sessionTrackItem);

      // Commented by Pranav
      for (var i = 0; i < this.sessionTrackList.length; i++) {
        this.sessionTrackList[i].position = i;
      }

      let key = this.multiUtilityService.addCategoryItem2(this.eventID, this.sessionTrackList, Constants.CATEGORY_SESSION_TRACK);
      if (key) {
        this.message = 'Type Added Successfully';
        this.categoryItemNewText = null;
        this.trackColorNewText = null;
        setTimeout(() => {
          this.message = null;
          this.checkData = true;
        }, 1000);
      }
    }
  }

  upCategoryItem(index) {
    if (index != 0) {
      this.swapCategoryItem(index, index - 1);
    }
  }

  downCategoryItem(index) {
    if (index != this.sessionTrackList.length - 1) {
      this.swapCategoryItem(index, index + 1);
    }
  }

  swapCategoryItem(index1, index2) {
    this.hasCategoryOrderChanged = true;

    let data = this.sessionTrackList[index1];
    this.sessionTrackList[index1] = this.sessionTrackList[index2];
    this.sessionTrackList[index2] = data;
  }

  confirmDeleteCategoryItem(item) {
    this.confirmationService.confirm({
      message: Constants.DELETE_MSG_SESSION_TRACK + ' ' + item.text,
      accept: () => {
        this.deleteCategoryItem(item);
      }
    });
  }

  deleteCategoryItem(item) {
    this.hasCategoryOrderChanged = true;

    this.categoryDeletedIdList.push(item.$key);
    let index: number = this.sessionTrackList.indexOf(item);
    if (index !== -1) {
      /* Remove category from List */
      this.sessionTrackList.splice(index, 1);

      /* Reset position in categoryList */
      for (var i = 0; i < this.sessionTrackList.length; i++) {
        this.sessionTrackList[i].position = i;
      }
    }
  }

  /** Category end */


  /** Category Session Type start */

  initSessionType(eventId) {
    this.multiUtilityService.getCategoryList(eventId, Constants.CATEGORY_SESSION_TYPE).subscribe(event => {
      console.log(event);
      if (event) {
        this.sessionTypeList = new Array();
        for (let key in event) {
          let sessionTypeItem = new SessionType();
          sessionTypeItem.$key = key;
          sessionTypeItem.position = event[key].position;
          sessionTypeItem.name = event[key].name;
          sessionTypeItem.color = event[key].color;
          this.sessionTypeList[event[key].position] = sessionTypeItem;
        }
        console.log('SessionType count	:	' + this.sessionTypeList.length);
      }
    });
  }

  onSessionTypeTextChange() {
    console.log('jnkjn');
    this.hasSessionTypeOrderChanged = true;
  }

  addSessionTypeItem() {
    if (this.sessionTypeItemNewText != null && this.sessionTypeItemNewText.trim().length > 0) {
      this.hasSessionTypeOrderChanged = true;

      let sessionTypeItem = new SessionType();
      sessionTypeItem.$key = null;
      sessionTypeItem.position = this.sessionTypeList.length;
      sessionTypeItem.name = this.sessionTypeItemNewText;
      sessionTypeItem.color = this.sessionTypeItemColorText;
      this.sessionTypeList.push(sessionTypeItem);

      // Commented by Pranav
      for (var i = 0; i < this.sessionTypeList.length; i++) {
        this.sessionTypeList[i].position = i;
      }

      let key = this.multiUtilityService.addCategoryItem2(this.eventID, this.sessionTypeList, Constants.CATEGORY_SESSION_TYPE);
      if (key) {
        this.message = 'Type Added Successfully';
        this.sessionTypeItemNewText = null;
        this.sessionTypeItemColorText = null;
        setTimeout(() => {
          this.message = null;
          this.checkData = true;
        }, 1000);
      }
    }
  }

  upSessionTypeItem(index) {
    if (index != 0) {
      this.swapSessionTypeItem(index, index - 1);
    }
  }

  downSessionTypeItem(index) {
    if (index != this.sessionTypeList.length - 1) {
      this.swapSessionTypeItem(index, index + 1);
    }
  }

  swapSessionTypeItem(index1, index2) {
    this.hasSessionTypeOrderChanged = true;

    let data = this.sessionTypeList[index1];
    this.sessionTypeList[index1] = this.sessionTypeList[index2];
    this.sessionTypeList[index2] = data;
  }

  confirmDeleteSessionTypeItem(item) {
    this.confirmationService.confirm({
      message: Constants.DELETE_MSG_SESSION_TYPE + ' ' + item.text,
      accept: () => {
        this.deleteSessionTypeItem(item);
      }
    });
  }

  deleteSessionTypeItem(item) {
    this.hasSessionTypeOrderChanged = true;

    this.sessionTypeDeletedIdList.push(item.$key);
    let index: number = this.sessionTypeList.indexOf(item);
    if (index !== -1) {
      /* Remove category from List */
      this.sessionTypeList.splice(index, 1);

      /* Reset position in sessionTypeList */
      for (var i = 0; i < this.sessionTypeList.length; i++) {
        this.sessionTypeList[i].position = i;
      }
    }
  }

  /** Category Session Type end */

  /** Session Hall start */
  initSessionHalls(eventId) {
    this.multiUtilityService.getCategoryList(eventId, Constants.NODE_SESSION_HALL).subscribe(event => {
      console.log(event);
      if (event) {
        this.sessionHallList = new Array();
        for (let key in event) {
          let sessionHallItem = new SessionHall();
          sessionHallItem.$key = key;
          sessionHallItem.position = event[key].position;
          sessionHallItem.name = event[key].name;
          this.sessionHallList[event[key].position] = sessionHallItem;
        }
        console.log('initCategoryList	:	' + this.sessionHallList.length);
      }
    });
  }

  addSessionHallItem() {
    if (this.sessionHallItemNewText != null && this.sessionHallItemNewText.trim().length > 0) {
      this.hasSessionHallOrderChanged = true;

      let sessionHallItem = new SessionHall();
      sessionHallItem.$key = null;
      sessionHallItem.position = this.sessionHallList.length;
      sessionHallItem.name = this.sessionHallItemNewText;
      this.sessionHallList.push(sessionHallItem);

      // Commented by Pranav
      for (var i = 0; i < this.sessionHallList.length; i++) {
        this.sessionHallList[i].position = i;
      }

      let key = this.multiUtilityService.addCategoryItem2(this.eventID, this.sessionHallList, Constants.NODE_SESSION_HALL);
      if (key) {
        this.message = 'Hall Added Successfully';
        this.sessionHallItemNewText = null;
        setTimeout(() => {
          this.message = null;
          this.checkData = true;
        }, 1000);
      }
    }
  }
  /** Session Hall ends */

//bulk upload for topics
  importSessionTopic(event: any, uploader: FileUpload){
    //debugger
    let bulkUploadTrigger: boolean = false;
    this.selectedFile = event.files[0];
    this.eximSessionService.importSessions(this.selectedFile).then(sessionBulk => {
      // console.log(sessionBulk);
      if (!this.validateFileNameTopicField(sessionBulk)) {
        this.message = 'It seems, some records don\'t have name value or name length should greater or equal to three character. Please fix before update.';
        setTimeout(() => {
          this.removeFileInstance(event, uploader, 0);
          this.message = null;
        }, 2000);
      } else {
        //removed code for the check to validate length
        var newDataToAdd = sessionBulk.filter((x)=>x["Id"] == "undefined" || x["Id"] == null)
        var updateDataToAdd = sessionBulk.filter((x)=>x.Id != "undefined" && x["Id"] != null)

        this.newImportSession = [];
            this.message = "Processing File";
            if(newDataToAdd.length > 0){
              newDataToAdd.forEach((sessionBulkItam, key) => {
                    let newSessionData: any={};
                    let page: any={};
                    page['endTime'] = this.validateExcelVal(sessionBulkItam, 'End Time');
                    page['eventList'] = false;
                    page['startTime'] = this.validateExcelVal(sessionBulkItam, 'Start Time');
                    var sessionData = this.sessionList.filter((x)=>x.$key == sessionBulkItam["Session Id"])[0];
                    var dateArray = new Date(sessionData["startTime"]).toLocaleDateString().split("/");
                    var date = dateArray[1] + (dateArray[0].length == 1 ? "0" + dateArray[0] : dateArray[0]) + dateArray[2];
                    newSessionData['title'] = this.validateExcelVal(sessionBulkItam, 'Title');
                    newSessionData['sessionId'] = this.validateExcelVal(sessionBulkItam, 'Session Id');
                    newSessionData['page'] = page;
                    newSessionData['startTime'] = date + " " + this.validateExcelVal(sessionBulkItam, 'Start Time')+":00";
                    newSessionData['endTime'] = date + " " + this.validateExcelVal(sessionBulkItam, 'End Time')+":00";
                    this.newImportSession.push(newSessionData)
                  if ((+key + 1) === newDataToAdd.length) bulkUploadTrigger = true;
                });
            }
            if(updateDataToAdd.length > 0){
              updateDataToAdd.forEach((sessionBulkItam, key) => {
                    this.sessionTopics
                    let updateSessionData: any={};
                    updateSessionData = this.sessionTopics[sessionBulkItam.Id]
                    let page: any=updateSessionData.page;
                    page['endTime'] = this.validateExcelVal(sessionBulkItam, 'End Time');
                    page['eventList'] = false;
                    page['startTime'] = this.validateExcelVal(sessionBulkItam, 'Start Time');
                    var sessionData = this.sessionList.filter((x)=>x.$key == sessionBulkItam["Session Id"])[0];
                    var dateArray = new Date(sessionData["startTime"]).toLocaleDateString().split("/");
                    var date = dateArray[1] + (dateArray[0].length == 1 ? "0" + dateArray[0] : dateArray[0]) + dateArray[2];
                    updateSessionData["$key"] = sessionBulkItam.Id
                    updateSessionData['title'] = this.validateExcelVal(sessionBulkItam, 'Title');
                    updateSessionData['sessionId'] = this.validateExcelVal(sessionBulkItam, 'Session Id');
                    updateSessionData['page'] = page;
                    updateSessionData['startTime'] = date + " " + this.validateExcelVal(sessionBulkItam, 'Start Time')+":00";
                    updateSessionData['endTime'] = date + " " + this.validateExcelVal(sessionBulkItam, 'End Time')+":00";
                    this.updateImportSession.push(updateSessionData)
                  if ((+key + 1) === updateDataToAdd.length) bulkUploadTrigger = true;
                });
            }

          setInterval(() => {
            if (bulkUploadTrigger) {
              this.removeFileInstance(event, uploader, 0);
              this.bulkUploadTopics();
              bulkUploadTrigger = false;
            }
          }, 1000);
      }
    }).catch(error => {
      console.log(error);
    });

  }

  /** bulk upload start */

  importSession(event: any, uploader: FileUpload) {
    let bulkUploadTrigger: boolean = false;
    this.selectedFile = event.files[0];
    this.eximSessionService.importSessions(this.selectedFile).then(sessionBulk => {
      // console.log(sessionBulk);
      if (!this.validateFileNameField(sessionBulk)) {
        this.message = 'It seems, some records don\'t have name value or name length should greater or equal to three character. Please fix before update.';
        setTimeout(() => {
          this.removeFileInstance(event, uploader, 0);
          this.message = null;
        }, 2000);
      } else {
        this.allSession = [];
        let allSessionCount: number = 0

        this.sessionService.getAllSession(this.eventID).then((list) => {
          list = list.val();
          if (list) {
            allSessionCount = Object.keys(list).length;
            for (let val in list) {
              this.allSession[val] = list[val];
            }
          }

          this.newImportSession = [];
          let newSessionData: any,
            newSessionIdCount = this.validateFileData(sessionBulk);

          if (allSessionCount != newSessionIdCount) {
            this.message = 'It seems, you don\'t have latest session list file. Please export session list before update.';
            setTimeout(() => {
              this.removeFileInstance(event, uploader, 0);
              this.message = null;
            }, 2000);
          }
          else {
            this.message = "Processing File";
            if (!newSessionIdCount) {
              sessionBulk.forEach((sessionItem, key) => {
                this.addBulkSession(sessionItem);
                if ((+key + 1) === sessionBulk.length) bulkUploadTrigger = true;
              });
            } else {
              sessionBulk.forEach((sessionBulkItam, key) => {

                if (sessionBulkItam[this.keys['id']] != undefined) {
                  newSessionData = this.allSession[sessionBulkItam[this.keys['id']]];
                  newSessionData['position'] = (+sessionBulkItam['__rowNum__'] - 1);

                  newSessionData['name'] = this.validateExcelVal(sessionBulkItam, this.keys['name']);
                  newSessionData['startTime'] = this.validateExcelVal(sessionBulkItam, this.keys['startTime']);
                  newSessionData['endTime'] = this.validateExcelVal(sessionBulkItam, this.keys['endTime']);
                  newSessionData['location'] = this.validateExcelVal(sessionBulkItam, this.keys['location']);

                  newSessionData['hasDetailsScreen'] = this.validateExcelVal(sessionBulkItam, this.keys['hasDetailsScreen']);
                  newSessionData['isQuestionAllowed'] = this.validateExcelVal(sessionBulkItam, this.keys['isQuestionAllowed']);
                  newSessionData['allowFeedback'] = this.validateExcelVal(sessionBulkItam, this.keys['allowFeedback']);
                  newSessionData['hasPolls'] = this.validateExcelVal(sessionBulkItam, this.keys['hasPolls']);
                  newSessionData['hasChatroom'] = this.validateExcelVal(sessionBulkItam, this.keys['hasChatroom']);

                  for(const [key,value] of Object.entries(newSessionData)){
                    let itemValue = (value as any)
                    itemValue = itemValue && typeof value == 'string' ? itemValue.trim().toLowerCase():null;
                    if(itemValue && key.startsWith("has") || itemValue == "true" || itemValue == "false"){
                      newSessionData[key] = itemValue == 'true' ? true:false
                    }
                  }
          

                  // newSessionData['hasCustomDescription'] = this.validateExcelVal(sessionBulkItam, this.keys['hasCustomDescription']);
                  // newSessionData['hasDifferentVenue'] = this.validateExcelVal(sessionBulkItam, this.keys['hasDifferentVenue']);
                  // newSessionData['hasHeader'] = this.validateExcelVal(sessionBulkItam, this.keys['hasHeader']);
                  // newSessionData['isTimeNotKnown'] = this.validateExcelVal(sessionBulkItam, this.keys['isTimeNotKnown']);
                  // newSessionData['location'] = this.validateExcelVal(sessionBulkItam, this.keys['location']);
                  // newSessionData['locationAddress'] = this.validateExcelVal(sessionBulkItam, this.keys['locationAddress']);
                  // newSessionData['showVenueTab'] = this.validateExcelVal(sessionBulkItam, this.keys['showVenueTab']);
                  // if (typeof newSessionData['isTimeNotKnown'] === 'boolean' && !newSessionData['isTimeNotKnown']) {
                  // }
                } else {
                  this.addBulkSession(sessionBulkItam);
                }
                if ((+key + 1) === sessionBulk.length) bulkUploadTrigger = true;

                // console.log(sessionBulkItam, key);


                // console.log(newSessionData);

                // if (sessionBulkItam[this.keys['id']] != undefined) {
                //   this.sessionService.getSingleSessionList(this.eventID, sessionBulkItam[this.keys['id']]).subscribe(tempSession => {
                //     if (tempSession) {
                //       let mergedSession = { ...tempSession, ...newSessionData };
                //       this.update(mergedSession, sessionBulkItam[this.keys['id']]);
                //     }
                //   });
                // } else {
                //   this.sessionService.addSessionDetails(newSessionData, this.eventID);
                // }
              });
            }
          }
          setInterval(() => {
            if (bulkUploadTrigger) {
              this.removeFileInstance(event, uploader, 0);
              this.bulkUploadSpeakers();
              bulkUploadTrigger = false;
            }
          }, 1000);
        });
      }
    }).catch(error => {
      console.log(error);
    });
  }

  bulkUploadSpeakers() {
    this.message = 'Speakers Import Successfully';
    if (this.allSession) {
      this.sessionService.addBulkSession(this.allSession, this.eventID);
    }
    if (this.newImportSession) {
      this.newImportSession.forEach(session => {
        this.sessionService.addSessionDetails(session, this.eventID);
      });
    }

    setTimeout(() => {
      this.message = null;
      this.getSessionList(this.eventID);
    }, 1000);
  }
  bulkUploadTopics() {
    this.message = 'Topics Import Successfully';
    if (this.newImportSession) {
      this.newImportSession.forEach(session => {
        this.sessionService.addSessionDetailsTopic(session, this.eventID);
      });
    }
    if(this.updateImportSession){
      this.updateImportSession.forEach(element => {
        this.sessionService.updateSessionTopicDetails(element,this.eventID);
      });
    }
    setTimeout(() => {
      this.message = null;
      this.getSessionList(this.eventID);
    }, 1000);
  }

  addBulkSession(sessionBulkItam) {
    let newSessionData = new Session();
    newSessionData['position'] = (+sessionBulkItam['__rowNum__'] - 1);
    newSessionData['name'] = this.validateExcelVal(sessionBulkItam, this.keys['name']);
    newSessionData['startTime'] = this.validateExcelVal(sessionBulkItam, this.keys['startTime']);
    newSessionData['endTime'] = this.validateExcelVal(sessionBulkItam, this.keys['endTime']);
    newSessionData['location'] = this.validateExcelVal(sessionBulkItam, this.keys['location']);
    newSessionData['hasDetailsScreen'] = this.validateExcelVal(sessionBulkItam, this.keys['hasDetailsScreen']);
    newSessionData['isQuestionAllowed'] = this.validateExcelVal(sessionBulkItam, this.keys['isQuestionAllowed']);
    newSessionData['hasPolls'] = this.validateExcelVal(sessionBulkItam, this.keys['hasPolls']);
    newSessionData['allowFeedback'] = this.validateExcelVal(sessionBulkItam, this.keys['allowFeedback']);
    newSessionData['hasChatroom'] = this.validateExcelVal(sessionBulkItam, this.keys['hasChatroom']);

    for(const [key,value] of Object.entries(newSessionData)){
      let itemValue = (value as any)
      itemValue = itemValue && typeof value == 'string' ? itemValue.trim().toLowerCase():null;
      if(itemValue && key.startsWith("has") || itemValue == "true" || itemValue == "false"){
        newSessionData[key] = itemValue == 'true' ? true:false
      }
    }
    
    // newSessionData['hasCustomDescription'] = this.validateExcelVal(sessionBulkItam, this.keys['hasCustomDescription']);
    // newSessionData['hasDifferentVenue'] = this.validateExcelVal(sessionBulkItam, this.keys['hasDifferentVenue']);
    // newSessionData['hasHeader'] = this.validateExcelVal(sessionBulkItam, this.keys['hasHeader']);
    // newSessionData['isTimeNotKnown'] = this.validateExcelVal(sessionBulkItam, this.keys['isTimeNotKnown']);
    // newSessionData['location'] = this.validateExcelVal(sessionBulkItam, this.keys['location']);
    // newSessionData['locationAddress'] = this.validateExcelVal(sessionBulkItam, this.keys['locationAddress']);
    // newSessionData['showVenueTab'] = this.validateExcelVal(sessionBulkItam, this.keys['showVenueTab']);
    // if (typeof newSessionData['isTimeNotKnown'] === 'boolean' && !newSessionData['isTimeNotKnown']) {
    // }
    this.newImportSession.push(newSessionData);
  }

  validateFileData(session: any): number {
    let count = 0;
    session.some(el => {
      if (el[this.keys['id']] !== undefined) {
        count++;
      };
    });
    return count;
  }
  validateTopicFileData(session: any): number {
    let count = 0;
    session.some(el => {
      if (el[this.keys['sessionID']] !== undefined) {
        count++;
      };
    });
    return count;
  }

  update(sessionDetails, sessionKey) {
    this.sessionService.updateSessionDetails(sessionDetails, this.eventID, sessionKey).then(res => {
      this.message = 'Updated Successfully';
    }).catch(error => {
      this.message = error.message;
    });
    setTimeout(function () {
      this.message = null;
      this.router.navigate([Constants.SESSION_FORM, this.eventId]);
    }.bind(this), 2000);
  }

  removeFileInstance(event: any, uploader: FileUpload, index: number) {
    uploader.remove(event.files[0], 0);
  }

  validateExcelVal(obj: any, key: string) {
    if (typeof obj[key] == 'string') obj[key] = obj[key].trim();
    // console.log(key, obj[key], 'qqqqqq', typeof obj[key]);
    if(obj[key] != undefined && obj[key] != '')
    {
      return obj[key];
    }
    else{
      if(typeof obj[key] === 'boolean'){
        return false;
      }
      else{
        return null
      }
    }
   // return (obj[key] != undefined && obj[key] != '') ? obj[key] : (typeof obj[key] === 'boolean') ? false : null;
  }

  validateFileNameField(session: any): boolean {
    let breakLoop: boolean;
    session.some(el => {
      if (el[this.keys['name']] !== undefined || !breakLoop) {
        if (el[this.keys['name']] === '' || el[this.keys['name']].length < 3) {
          breakLoop = true;
        }
      } else {
        breakLoop = true;
      }
    });

    if (breakLoop) return false;
    else return true;
  }

  validateFileNameTopicField(session: any): boolean {
    let breakLoop: boolean;
    session.some(el => {
      if (el[this.keys['name']] !== undefined || !breakLoop) {
        if (el[this.keys['name']] === '') {
          breakLoop = true;
        }
      } else {
        breakLoop = true;
      }
    });

    if (breakLoop) return false;
    else return true;
  }

  getEventAliasId(id) {
		this.sessionService.getEventBasicInfo(id).subscribe(event => {
			if (event) {
				this.aliasId = event.aliasId;
			}
		})
	}
  exportTopics(){
    this.allSessionTopics = [];
    let data: any;
    // all db speakers details
    this.sessionService.getAllSessionTopics(this.eventID).then((list) => {
      list = list.val();
      if (list) {
        // debugger
        for (let val in list) {
          data = {};
          data['Id'] = val;
          data['Title'] = list[val].title;
          data['Session Id'] = list[val].sessionId;
          data['Start Time'] = list[val].page.startTime;
          data['End Time'] = list[val].page.endTime;

          this.allSessionTopics.push(data);
        }
        this.eximSessionService.generateFile(this.allSessionTopics, this.aliasId,"topics");
      }
    });
  }

  exportSession() {
    // getAll
    this.allSession = [];
    let data: any;
    // all db speakers details
    this.sessionService.getAllSession(this.eventID).then((list) => {
      list = list.val();
      if (list) {
        for (let val in list) {
          data = {};
          data[this.keys['id']] = val;
          data[this.keys['name']] = list[val].name;
          data[this.keys['startTime']] = list[val].startTime;
          data[this.keys['endTime']] = list[val].endTime;
          data[this.keys['location']] = list[val].location;
          data[this.keys['hasDetailsScreen']] = list[val].hasDetailsScreen ? 'true' : 'false';
          data[this.keys['isQuestionAllowed']] = list[val].isQuestionAllowed ? 'true' : 'false';
          data[this.keys['allowFeedback']] = list[val].allowFeedback ? 'true' : 'false';
          data[this.keys['hasPolls']] = list[val].hasPolls ? 'true' : 'false';
          data[this.keys['hasChatroom']] = list[val].hasChatroom ? 'true' : 'false';
          this.allSession[list[val].position] = data;
        }
        this.eximSessionService.generateFile(this.allSession, this.aliasId,"session");
      }
    });
  }

  /** bulk upload end */

}



// WEBPACK FOOTER //
// /app/src/app/event/sessions-form/sessions-form.component.ts